import normalize from './normalize';
import processRules from './processRules';

/**
 * Create Redux middleware function which normalizes entities
 */
export default function getNormalizerMiddleware(arrayRules, callback) {
  const rules = processRules(arrayRules);
  return () => next => action => {
    // entityType is added by autogenerated actions. Normalization only applies
    // to autogenerated components.
    const { payload, meta } = action;
    const entityType = meta && meta.entityType;
    if (entityType && payload && rules[entityType]) {
      meta.entities = {};
      action.payload = normalize(rules, entityType, payload, meta.entities);
      callback && callback(entityType, payload);
    }
    return next(action);
  };
}
